import { PartnershipBaseEntity } from "./PartnershipEntity";

export enum UserType {
  user = 'user',
  admin = 'admin',
  partner = 'partner'
}
export interface UserEntity {
  id: string;
  name: string | null;
  email: string | null;
  phone: string | null;
  type: UserType;
  email_verified_at: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  document_number: string | null;
  balance: number;
  partnership_id: string | null;
  partnership: PartnershipBaseEntity | null;
  sessions_count: number;
  address: UserAddress;
}

export type UserAddress = {
  id: string;
  user_id: string;
  line_1: string;
  zip_code: string;
  city: string;
  state: string;
  country: string;
  created_at: string;
  updated_at: string;
  line_2: string | null;
  deleted_at: string | null;
};
